import React from 'react'
import {ChevronDown, Bell, ExternalLink, Lock, Minus, Plus} from 'react-feather'
import Main_Logo from '../../images/Main_Logo.png'
import Metamask from '../../images/metamask.png'
import { UncontrolledCollapse, Button } from 'reactstrap';

function TableComponent() {
    return (
        <div className="container">
            <div className="card card_custom">
            <div class="table-responsive">
                <table class="zui-table zui-table-rounded col-md-12 col-sm-12 w-100">
                    <tbody>
                        {/* First Row */}
                        <tr>
                            <td>
                                <div className="d-flex justify-content-between">
                                    <img src={Main_Logo} style={{height: '50px', margin: '20px'}} />
                                        <div className="margin col-1">
                                            <span className="h_1">Earn SFINU</span><br />
                                            <span className="h_2">Stake SFINU</span><br />
                                            <span className="h_3">Refl. BNB</span><br />
                                            <span className="h_4">Unlocked</span>
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_2">SFINU Earned</span><br />
                                            <span className="h_1_black">45,512.25136</span><br />
                                            <span className="h_3">~15.46USD</span><br />
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_3">APR</span><br />
                                            <span className="h_5">46.85%</span><br />
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_3">Total Staked</span><br />
                                            <span className="h_5">435,654,678 SFINU</span><br />
                                        </div>

                                        <div className="margin col-2">
                                            <span className="h_3">Ends In</span><br />
                                            <span className="h_5">9,023,334 blocks</span><br />
                                        </div>

                                        <div>
                                            <Bell size={20} style={{margin: '20px'}} color="#fcb034" />
                                        </div>

                                        <div className="details d-flex col-1">
                                            <a id="toggler1" className="h_3">Details <ChevronDown size={18} color="#fcb034" /></a>
                                        </div>
                                </div>

                                <div className="container expanded-area">
                                    <UncontrolledCollapse toggler="#toggler1">
                                        <div className="d-flex justify-content-center">
                                            <div className="m-3 col-2">
                                                <span className="h_2">Ends in: 9,023,334 blocks</span><br /><br />

                                                <a className="h_3">See Token Info <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">View Website <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">View Contract <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">Add to Metamask <img src={Metamask} style={{width : '20px'}} /></a><br />

                                                <Button size="sm" type="primary" className="custom_expand_area_button mt-3 custom_expand_area_button_text"><Lock size={15} style={{marginTop: '-4px', marginRight: '7px'}} />Lockup</Button>
                                            </div>

                                            <div className="m-3 col-2">
                                                <span className="custom_expand_area_text_yellow">SFINU EARNED</span><br />
                                              <span className="custom_expand_area_text_black">435,875.23123</span><br />
                                                <span className="h_3">~31.48 USD</span><br /><br />

                                                <span className="custom_expand_area_text_yellow">BNB REFLECTED</span><br />
                                                <span className="custom_expand_area_text_black">0.08542</span><br />
                                                <span className="h_3">~23.56 USD</span>
                                            </div>

                                            <div className="mt-4 col-2">
                                                <Button size="sm" type="primary" className="col-12 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br /><br /><br />

                                                <Button size="sm" type="primary" className="col-12 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                                                <Button size="sm" type="primary" className="col-12 mt-2 custom_expand_area_button custom_expand_area_button_text">Harvest</Button>
                                            </div>

                                            <div className="m-3 col-2">
                                                <span className="h_3">LOCK DURATION</span><br />
                                                <span className="h_3">DEPOSIT FEE</span><br />
                                                <span className="h_3">WITHDRAW FEE</span><br /><br />

                                                <span className="h_2">SFINU STAKED</span><br />
                                                <span className="custom_expand_area_text_black">560,000,000.00000</span><br />
                                                <span className="h_3">~6,546.22 USD</span><br /><br />

                                                <span className="h_2">LOCKED</span><br />
                                                <span className="h_4">560,000,000.0000</span>
                                            </div>

                                            <div className="mt-3 col-2">
                                                 <span className="h_4_black">45 Days</span><br />
                                                 <span className="h_4_black">0.00%</span><br />
                                                 <span className="h_4_black">0.20%</span><br /><br /><br />
                                                
                                                <div className="d-flex">
                                                 <Button className="custom_outline_button" outline color="info"><Minus /></Button>
                                                 <Button className="custom_outline_button" outline color="info"><Plus /></Button>
                                                 </div>
                                            </div>
                                        </div>
                                    </UncontrolledCollapse>
                                </div>
                            </td>
                            
                        </tr>

                        {/* Second Row */}
                        <tr>
                            <td>
                                <div className="d-flex justify-content-between">
                                    <img src={Main_Logo} style={{height: '50px', margin: '20px'}} />
                                        <div className="margin col-1">
                                            <span className="h_1">Earn SFINU</span><br />
                                            <span className="h_2">Stake SFINU</span><br />
                                            <span className="h_3">Refl. BNB</span><br />
                                            <span className="h_4">Unlocked</span>
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_2">SFINU Earned</span><br />
                                            <span className="h_1_black">45,512</span><br />
                                            <span className="h_3">~15.46USD</span><br />
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_3">APR</span><br />
                                            <span className="h_5">46.85%</span><br />
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_3">Total Staked</span><br />
                                            <span className="h_5">435,654 SFINU</span><br />
                                        </div>

                                        <div className="margin col-2">
                                            <span className="h_3">Ends In</span><br />
                                            <span className="h_5">9,023 blocks</span><br />
                                        </div>

                                        <div>
                                            <Bell size={20} style={{margin: '20px'}} color="#fcb034" />
                                        </div>

                                        <div className="details d-flex col-1">
                                            <a id="toggler2" className="h_3">Details <ChevronDown size={18} color="#fcb034" /></a>
                                        </div>
                                </div>

                                <div className="container expanded-area">
                                    <UncontrolledCollapse toggler="#toggler2">
                                        <div className="d-flex justify-content-center">
                                            <div className="m-3 col-2">
                                                <span className="h_2">Ends in: 9,023,334 blocks</span><br /><br />

                                                <a className="h_3">See Token Info <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">View Website <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">View Contract <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">Add to Metamask <img src={Metamask} style={{width : '20px'}} /></a><br />

                                                <Button size="sm" type="primary" className="custom_expand_area_button mt-3 custom_expand_area_button_text"><Lock size={15} style={{marginTop: '-4px', marginRight: '7px'}} />Lockup</Button>
                                            </div>

                                            <div className="m-3 col-2">
                                                <span className="custom_expand_area_text_yellow">SFINU EARNED</span><br />
                                              <span className="custom_expand_area_text_black">435,875</span><br />
                                                <span className="h_3">~31.48 USD</span><br /><br />

                                                <span className="custom_expand_area_text_yellow">BNB REFLECTED</span><br />
                                                <span className="custom_expand_area_text_black">0.08542</span><br />
                                                <span className="h_3">~23.56 USD</span>
                                            </div>

                                            <div className="mt-4 col-2">
                                                <Button size="sm" type="primary" className="col-12 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br /><br /><br />

                                                <Button size="sm" type="primary" className="col-12 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                                                <Button size="sm" type="primary" className="col-12 mt-2 custom_expand_area_button custom_expand_area_button_text">Harvest</Button>
                                            </div>

                                            <div className="m-3 col-2">
                                                <span className="h_3">LOCK DURATION</span><br />
                                                <span className="h_3">DEPOSIT FEE</span><br />
                                                <span className="h_3">WITHDRAW FEE</span><br /><br />

                                                <span className="h_2">SFINU STAKED</span><br />
                                                <span className="custom_expand_area_text_black">560,000,000</span><br />
                                                <span className="h_3">~6,546.22 USD</span><br /><br />

                                                <span className="h_2">LOCKED</span><br />
                                                <span className="h_4">560,000,000.0000</span>
                                            </div>

                                            <div className="mt-3 col-2">
                                                 <span className="h_4_black">45 Days</span><br />
                                                 <span className="h_4_black">0.00%</span><br />
                                                 <span className="h_4_black">0.20%</span><br /><br /><br />
                                                
                                                <div className="d-flex">
                                                 <Button className="custom_outline_button" outline color="info"><Minus /></Button>
                                                 <Button className="custom_outline_button" outline color="info"><Plus /></Button>
                                                 </div>
                                            </div>
                                        </div>
                                    </UncontrolledCollapse>
                                </div>
                            </td>
                            
                        </tr>

                        {/* Third Row */}
                        <tr>
                            <td>
                                <div className="d-flex justify-content-between">
                                    <img src={Main_Logo} style={{height: '50px', margin: '20px'}} />
                                        <div className="margin col-1">
                                            <span className="h_1">Earn SFINU</span><br />
                                            <span className="h_2">Stake SFINU</span><br />
                                            <span className="h_3">Refl. BNB</span><br />
                                            <span className="h_4">Unlocked</span>
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_2">SFINU Earned</span><br />
                                            <span className="h_1_black">45,512</span><br />
                                            <span className="h_3">~15.46USD</span><br />
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_3">APR</span><br />
                                            <span className="h_5">46.85%</span><br />
                                        </div>

                                        <div className="margin col-1">
                                            <span className="h_3">Total Staked</span><br />
                                            <span className="h_5">435,654 SFINU</span><br />
                                        </div>

                                        <div className="margin col-2">
                                            <span className="h_3">Ends In</span><br />
                                            <span className="h_5">9,023 blocks</span><br />
                                        </div>

                                        <div>
                                            <Bell size={20} style={{margin: '20px'}} color="#fcb034" />
                                        </div>

                                        <div className="details d-flex col-1">
                                            <a id="toggler3" className="h_3">Details <ChevronDown size={18} color="#fcb034" /></a>
                                        </div>
                                </div>

                                <div className="container expanded-area">
                                    <UncontrolledCollapse toggler="#toggler3">
                                        <div className="d-flex justify-content-center">
                                            <div className="m-3 col-2">
                                                <span className="h_2">Ends in: 9,023,334 blocks</span><br /><br />

                                                <a className="h_3">See Token Info <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">View Website <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">View Contract <ExternalLink size={18} style={{marginTop: '-4px'}} /></a><br />
                                                <a className="h_3">Add to Metamask <img src={Metamask} style={{width : '20px'}} /></a><br />

                                                <Button size="sm" type="primary" className="custom_expand_area_button mt-3 custom_expand_area_button_text"><Lock size={15} style={{marginTop: '-4px', marginRight: '7px'}} />Lockup</Button>
                                            </div>

                                            <div className="m-3 col-2">
                                                <span className="custom_expand_area_text_yellow">SFINU EARNED</span><br />
                                              <span className="custom_expand_area_text_black">435,875</span><br />
                                                <span className="h_3">~31.48 USD</span><br /><br />

                                                <span className="custom_expand_area_text_yellow">BNB REFLECTED</span><br />
                                                <span className="custom_expand_area_text_black">0.08542</span><br />
                                                <span className="h_3">~23.56 USD</span>
                                            </div>

                                            <div className="mt-4 col-2">
                                                <Button size="sm" type="primary" className="col-12 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br /><br /><br />

                                                <Button size="sm" type="primary" className="col-12 custom_expand_area_button custom_expand_area_button_text">Compound</Button><br />
                                                <Button size="sm" type="primary" className="col-12 mt-2 custom_expand_area_button custom_expand_area_button_text">Harvest</Button>
                                            </div>

                                            <div className="m-3 col-2">
                                                <span className="h_3">LOCK DURATION</span><br />
                                                <span className="h_3">DEPOSIT FEE</span><br />
                                                <span className="h_3">WITHDRAW FEE</span><br /><br />

                                                <span className="h_2">SFINU STAKED</span><br />
                                                <span className="custom_expand_area_text_black">560,000,000</span><br />
                                                <span className="h_3">~6,546.22 USD</span><br /><br />

                                                <span className="h_2">LOCKED</span><br />
                                                <span className="h_4">560,000,000.0000</span>
                                            </div>

                                            <div className="mt-3 col-2">
                                                 <span className="h_4_black">45 Days</span><br />
                                                 <span className="h_4_black">0.00%</span><br />
                                                 <span className="h_4_black">0.20%</span><br /><br /><br />
                                                
                                                <div className="d-flex">
                                                 <Button className="custom_outline_button" outline color="info"><Minus /></Button>
                                                 <Button className="custom_outline_button" outline color="info"><Plus /></Button>
                                                </div>
                                            </div>
                                        </div>
                                    </UncontrolledCollapse>
                                </div>
                            </td>
                            
                        </tr>
                        

                        {/* Last Row */}
                        <tr className="see_more_section">
                            <td className="text-center card_header_black_bold" style={{cursor: 'pointer'}}>See More <ChevronDown size={20} /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
        </div>
    )
}

export default TableComponent
